__turbopack_context__.v({
  "breadcrumbCurrent": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbCurrent",
  "breadcrumbItem": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbItem",
  "breadcrumbLink": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbLink",
  "breadcrumbSeparator": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbSeparator",
  "breadcrumbs": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs",
  "breadcrumbsList": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbsList",
  "breadcrumbs_alignment-center": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_alignment-center",
  "breadcrumbs_alignment-left": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_alignment-left",
  "breadcrumbs_density-compact": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_density-compact",
  "breadcrumbs_density-no-padding": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_density-no-padding",
  "breadcrumbs_inverse": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_inverse",
  "breadcrumbs_leadingDivider": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_leadingDivider",
  "breadcrumbs_trailingDivider": "Breadcrumbs-module-scss-module__Ir3W5a__breadcrumbs_trailingDivider",
});
